<template>
  <custom-dialog width="600px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body notice-bd">
      <div class="information-body">
        <el-row>
          <el-col :span="24">
            <div class="grid-title">{{ $t('base_notice_see_dialog.biao_ti') }}</div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content">{{ info.title }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-title">{{ $t('base_notice_see_dialog.nei_rong') }}</div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content" v-html="info.content"></div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-title">{{ $t('base_notice_see_dialog.fa_bu_shi_jian') }}</div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content">{{ momentAmPm($momentLocal(info.beginTime)) }} ~ {{ momentAmPm($momentLocal(info.endTime)) }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-title">{{ $t('base_notice_see_dialog.shi_fou_tan_chuang') }}</div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content">{{ info.isPop ? $t('Common.com_yes') : $t('Common.com_no') }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-title">
              {{ $t('base_notice_see_dialog.tui_song_jue_se') }}
            </div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content">{{ info.pushRangeName && info.pushRangeName.join('、') }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-title">{{ $t('base_notice_see_dialog.tui_song_fan_wei') }}</div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content">{{ info.pushRoleName && info.pushRoleName.join('、') }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-title">{{ $t('base_notice_see_dialog.tui_song_qu_dao') }}</div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content">{{ info.pushChannelName && info.pushChannelName.join('、') }}</div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <div class="grid-title">{{ $t('base_notice_see_dialog.fa_bu_zhuang_tai') }}</div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content">{{ bas_notice_state[info.state] }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-title">{{ $t('base_notice_see_dialog.geng_xin_ren') }}</div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content">{{ info.creator }}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="grid-title">{{ $t('base_notice_see_dialog.geng_xin_shi_jian') }}</div>
          </el-col>
          <el-col :span="24">
            <div class="grid-content">{{ info.gmtModified }}</div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <!-- <el-button size="small" type="primary" @click="saveNotice">确定</el-button> -->
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      info: {
        title: '',
        beginTime: '',
        endTime: '',
        isPop: '',
        state: '',
        publishTime: '',
        content: '',
        pushChannelName: '',
        pushRoleName: '',
        pushRangeName: '',
        creator: '',
        gmtCreate: ''
      },
      bas_notice_state: {}
    };
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.getDictionary('bas_notice_state', (data) => {
        this.bas_notice_state = this.$transformDicValue(data.bas_notice_state);
      });
      if (this.model.type === 'see') {
        this.getNoticeInfo();
      }
    },
    getNoticeInfo: function () {
      this.$getJSON(`${apis.noticeInfo}/${this.model.id}`).then((res) => {
        this.info = res.data;
        this.info.content = this.info.content.replace(/(\r\n|\n|\r)/g, '<br />');
      });
    }
  }
};
</script>

<style lang="scss">
.notice-bd {
  .information-body {
    .el-row {
      color: #262626;
      margin-bottom: 12px;
      line-height: 17px;
      font-size: 12px;
      > .el-col:first-child {
        font-size: 12px;
        font-weight: bold;
        color: rgba(73, 80, 87, 1);
        line-height: 28px;
      }
      > .el-col:last-child {
        font-size: 12px;
        color: rgba(108, 117, 125, 1);
        line-height: 22px;
      }
    }
  }
}
</style>
